import React from "react";

export const ClipboardUser = ({ size, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 384 512"
      style={{ transition: "fill 0.2s ease-in" }}
    >
      <path
        fill={fill}
        d="M320 64h-49.61C262.1 27.48 230.7 0 192 0S121 27.48 113.6 64H64C28.65 64 0 92.66 0 128v320c0 35.34 28.65 64 64 64h256c35.35 0 64-28.66 64-64V128C384 92.66 355.3 64 320 64zM192 48c13.23 0 24 10.77 24 24S205.2 96 192 96S168 85.23 168 72S178.8 48 192 48zM336 448c0 8.82-7.178 16-16 16h-1.613C310.7 418.6 271.5 384 224 384H160c-47.54 0-86.73 34.64-94.39 80H64c-8.822 0-16-7.18-16-16V128c0-8.82 7.178-16 16-16h18.26C80.93 117.1 80 122.4 80 128v16C80 152.8 87.16 160 96 160h192c8.836 0 16-7.164 16-16V128c0-5.559-.9316-10.86-2.264-16H320c8.822 0 16 7.18 16 16V448zM192 224C156.7 224 128 252.7 128 288c0 35.34 28.65 64 64 64s64-28.66 64-64C256 252.7 227.3 224 192 224z"
      />
    </svg>
  );
};
